import R from 'ramda'

const RETWEET_TWEET_DISPLAY_TYPE = 'Retweet of a Tweet'
const INITIAL_TWEET_TRIGGER_TYPE = 'INITIAL_TWEET'
const RETWEET_OF_TRIGGER_TYPE = 'RETWEET_OF'

const isRetweetFormTrigger = R.propEq('type', RETWEET_TWEET_DISPLAY_TYPE)

const getTriggerType = R.cond([
  [R.propEq('action', 'NEW_TWEET'), R.always(INITIAL_TWEET_TRIGGER_TYPE)],
  [R.propEq('action', 'EXISTING_TWEET'), R.always(RETWEET_OF_TRIGGER_TYPE)]
])

const getResult = R.cond([
  [R.propEq('action', 'NEW_TWEET'), R.always(RETWEET_OF_TRIGGER_TYPE)]
])

const convertRetweetFormTriggerToWidgetTrigger = R.applySpec({
  type: getTriggerType,
  result: getResult,
  data: R.prop('value'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  operator: R.always('AND'),
  primary: R.T,
  isPromotedTweet: R.prop('isPromotedTweet')
})

export { isRetweetFormTrigger, convertRetweetFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/retweet.js